import React from 'react';
import { email } from '../utils/DictionaryManagementUtils';
import DefaultPanelManuelRecipient from '../components/PanelsComponents/ManuelRecipient/DefaultPanelManuelRecipient';

//= ========================================================================
const Panel_G07b_SplitPaymentToEmailManually = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultPanelManuelRecipient
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
    manualName={email}
  />
);

export default Panel_G07b_SplitPaymentToEmailManually;
